// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"OsfAccessOnly_checkbox-container__Zjfjh","button":"OsfAccessOnly_button__3kbX4","center":"OsfAccessOnly_center__3792I"};